{
  "title": "Company & Branch Profiles",
  "subtitle": "Configure multi-company / multi-branch organizational structure.",
  "editCompany": "Edit Company",
  "addBranch": "Add Branch",
  "financial": "Financial Configuration",
  "fiscalYear": "Fiscal Year Start",
  "currency": "Currency",
  "taxSystem": "Tax System",
  "branches": "Operating Branches & Warehouses",
  "branchLimitLabel": "{{count}} of {{limit}} branches used",
  "branchLimitUnlimitedLabel": "{{count}} branches (unlimited)",
  "table": {
    "code": "Branch Code",
    "name": "Name",
    "address": "Address",
    "manager": "Manager",
    "warehouses": "Warehouses",
    "status": "Status"
  },
  "form": {
    "name": "Company Name",
    "cin": "CIN",
    "gstin": "GSTIN",
    "email": "Primary Contact Email",
    "website": "Corporate Website",
    "parentCompanyName": "Parent Company",
    "industrySector": "Industry Sector",
    "fiscalYearStartMonth": "Fiscal Start Month",
    "fiscalYearStartDay": "Fiscal Start Day",
    "currency": "Currency",
    "taxSystem": "Tax System",
    "state": "State (for GST)",
    "stateNone": "— Not set —",
    "branchCode": "Branch Code",
    "branchName": "Branch Name",
    "address": "Address",
    "validation": {
      "nameRequired": "Name is required.",
      "branchCodeRequired": "Branch code is required."
    }
  },
  "deleteBranch": {
    "message": "This branch will be deleted. Branches with warehouses assigned cannot be deleted."
  }
}
